<template>
  <div class="box-align-center box-pack-between main">
    <div class="whiteBg">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="使用情况统计" name="0">
          <echartsMap></echartsMap>
        </el-tab-pane>
        <el-tab-pane label="热门资源统计" name="1">
          <hotMap></hotMap>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import echartsMap from './components/echartsMap.vue';
import hotMap from './components/hotMap.vue';

var that = null;
export default {
  components: {
    echartsMap,
    hotMap,
  },
  data() {
    return {
      activeName: '0',
      currentIndex: 0,
    };
  },
  mounted() {
    that = this;
  },
  methods: {
    //切换菜单
    handleSelect(index) {
      that.currentIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-submenu .el-menu-item {
  min-width: initial;
}
.main {
  padding: 12px;

  .main-left {
    flex-shrink: 0;
    width: 180px;
  }

  .main-right {
    flex: 1;
  }
}
</style>
